import { Injectable, EventEmitter } from '@angular/core';
import { List } from 'linqts';
import { EmailMessage } from '../../_models';
import * as _ from "lodash"

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  date:List<EmailMessage>
  notifer = new EventEmitter();
  constructor() {
    this.date = new List();
   }

   getAll():EmailMessage[]{
     return this.date.ToArray();
   }
   count(){
     return this.date.Count();
   }

   getbyId(id:number):EmailMessage{
    return this.date.Where(e=>e.id==id).SingleOrDefault();
  }
  insert(message :EmailMessage )
  {
    this.date.Add(message);
    this.notifer.emit(this.date.ToArray());
  }

  update(message :EmailMessage)
  {
   let i=  this.date.Where(e=>e.id == message.id).SingleOrDefault();
   if(i)
   {
      i = _.cloneDeep(message);
      this.notifer.emit(this.date.ToArray());
   }

  }

  remove(message :EmailMessage)
  {
    this.date.Remove(message);
    this.notifer.emit(this.date.ToArray());
  }

   
}
